import { CSSProperties, FC, ReactNode, useEffect, useRef, useState } from "react";

import { ClassName } from "config/types";

import classNames from "classnames";

interface IProps {
  className?: ClassName;
  offsetFromTop?: number;
  children?: ReactNode;
}

export const FixedWrapper: FC<IProps> = ({ className, offsetFromTop = 0, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [fixedStyle, setFixedStyle] = useState<CSSProperties>();

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof IntersectionObserver === "undefined") {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry?.isIntersecting) {
        return;
      }

      // Once the element scrolls into view, pin it at its current viewport
      // position. We only need the first entry, so stop observing afterwards.
      setFixedStyle({ position: "fixed", top: entry.boundingClientRect.top + offsetFromTop });
      observer.disconnect();
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [offsetFromTop]);

  return (
    <div ref={ref} className={classNames(className)} style={fixedStyle}>
      {children}
    </div>
  );
};
